import { LoginParams } from '../types/LoginParams';
import { SessionInfoResult } from '../types/SessionInfo';
import { VizPortalClientMethod } from '../VizPortalClientMethod';

export const LoginMethod = new VizPortalClientMethod<LoginParams, SessionInfoResult>('login');
